import React from "react";

/**
 * Header Component
 * Title and "Add Phase" accent button
 */
const Header = ({ hasPhases, onAddPhase, canEditFormat = true }) => {
  return (
    <div className="flex items-center justify-between">
      <h3 className="text-[22px] font-normal text-[#FEFCEB] m-0">Format</h3>
      {canEditFormat && hasPhases && (
        <button
            className="bg-[#00E7FF] hover:opacity-50 text-[#021529] text-[15px] font-medium px-4 py-2 rounded-full flex items-center transition-all active:scale-95"
            onClick={onAddPhase}
          >
            Add stage
        </button>
      )}
    </div>
  );
};

export default Header;
